import { render, staticRenderFns } from "./HighlightButton.vue?vue&type=template&id=2ab852f7&scoped=true&"
import script from "./HighlightButton.vue?vue&type=script&lang=js&"
export * from "./HighlightButton.vue?vue&type=script&lang=js&"
import style0 from "./HighlightButton.vue?vue&type=style&index=0&id=2ab852f7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab852f7",
  null
  
)

export default component.exports